export const NAV = {
  logoLink: 'nav-logo-link',
  navHome: 'nav-link-home',
  navPrograms: 'nav-link-programs',
  navSuccess: 'nav-link-success',
  navLearningHub: 'nav-link-learning-hub',
  navFeedback: 'nav-link-feedback',
  navAbout: 'nav-link-about',
  navGallery: 'nav-link-gallery',
  navContact: 'nav-link-contact',
  navCtaConsult: 'nav-cta-consultation-button',
  mobileMenuToggle: 'nav-mobile-menu-toggle',
  floatingWhatsapp: 'floating-whatsapp-button',
  footerSocialLinkedin: 'footer-social-linkedin',
  footerSocialYoutube: 'footer-social-youtube',
  footerSocialInstagram: 'footer-social-instagram',
};
